import * as React from 'react'

const AccessDenied = () => {
    return <p>You don&apos;t have permission to this data.</p>
}

export default AccessDenied
